export default __webpack_public_path__ + "static/media/photo--sm--78.0e768649.jpg";